var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"flex"}},[_c('div',{staticClass:"sidebar"},[_c('ul',[_c('li',[_c('router-link',{attrs:{"to":"/brasspire/ledger"}},[_vm._v("Darrynt Cauladra's Flower Ledger")])],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }